import React, { Component } from "react";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import Paging from "../../../components/Paging";
import { SCHEDULE_LIST, SCHEDULE_UPDATE_STATUS } from "../endpoints";
import CustomModal from "../CustomModal";
import { NavLink } from "react-router-dom";
import DropdownView from "./DropdownView";
import XLSX from 'xlsx'

class ScoreTugasOffline extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSiswa : [],
            dataSiswaNotE : [],
            dataExport    : [],
            dataExportNotE   : [],
            dataParticipant: [],
            exam_cat_id: 0,
            ratarata:0,
            pageCount: 0,
            currentPage: 0,
            isLoading: false,
            isButtonLoading: false,
            isModalShow: false,
            modalShow:false,
            examId:"",
            nama:"",
            kelasNama:"",
            participant_id:"",
            dataExam:"",
            urlZip:'',
        };

        this.toggle = this.toggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeStatus = this.handleChangeStatus.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.exportFile = this.exportFile.bind(this);
        this.downloadZip = this.downloadZip.bind(this);

    }

    downloadZip() {
        this.setState({ isButtonLoading: true });

        const params = qs.stringify({
            tugas_id:this.props.match.params.tugas_id,
            participant_id:this.state.participant_id
        });

        axios.post("/tugas/siswa-files?"+params)
        .then(response => {
            const result = response.data;
            if (result.success) {
                this.setState({
                    isButtonLoading : false,
                    isLoading : false,
                    urlZip : result.data,
                },()=>{
                    window.open(this.state.urlZip);
                    Alert.success(result.message);
                });
            }else{
                this.setState({
                    isButtonLoading : false,
                    isLoading : false
                },()=>{
                    Alert.error(result.message);
                });
            }
        })
        .catch(error => {
            console.log(error);
            this.setState({ isLoading: false,isButtonLoading : false });
            Alert.error("Gagal terhubung ke server!");
        });
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    toggleModal(e) {
        this.setState({
            modalShow: !this.state.modalShow,
            examId : e
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        const newState = {
            [name]: value
        }

        this.setState(
            newState
        )
    }

    handleHapusButton(a) {
        this.setState({ isButtonLoading: true });

        const url = '/exam/delete-exam'

        let newState = {
            locale:"id",
            platform:"web",
            user_id:localStorage.SISMART_USER_ID,
            exam_id:a
        };

        axios({
            method: "post",
            url: url,
            data: qs.stringify(newState)
        })

            .then(response => {
                const result = response.data;

                if (result.status) {
                    Alert.success(result.text);
                    this.props.history.replace(
                        "/exam/schedule"
                    );
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }

                    this.setState({ isButtonLoading: false });
                }
            })

            .catch(error => {
                console.log(error);
                this.setState({ isButtonLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });

        this.setState({ modalShow: false });
        window.location.reload()
    }

    handlePageClick(data) {
        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    handleChangeStatus(exam_id, exam_status) {
        axios
            .post(SCHEDULE_UPDATE_STATUS, qs.stringify({ exam_id, exam_status }))
            .then(response => {
                this.loadData();
            })
            .catch(error => {
                console.log(error);
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadExport() {
        this.setState({ isButtonLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            locale:"id",
            platform:"web",
            tugas_id:this.props.match.params.tugas_id,
            participant_id:this.state.participant_id
        });

        axios({
            method: "post",
            url: "/tugas/siswa?" + params
        })

            .then(response => {
                const result = response.data;

                if (result.success === true) {
                    this.setState({
                        dataSiswa: result.data['jawab'],
                        dataSiswaNotE: result.data['notJawab'],
                        kelasNama : result.data.kelasNama,
                        exam_title: result.data.exam_title,
                        isButtonLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isButtonLoading: false });
                }
            })
            .catch(error => {
                this.setState({ isButtonLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadData() {
        this.setState({ isLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            locale:"id",
            platform:"web",
            tugas_id:this.props.match.params.tugas_id,
            cari: this.state.nama,
            participant_id:this.state.participant_id
        });

        axios({
            method: "post",
            url: "tugas/siswa?" + params
        })

            .then(response => {
                const result = response.data;

                if (result.success === true) {

                    const dataParticipant = result.data['kelas'].map((item,i) => ({
                        key: item.kelas_id,
                        value: item.kelas_nama
                    }));

                    this.setState({
                        tanggal_mulai : result.data.tugas_create_date,
                        due_date : result.data.tugas_due_date,
                        guru : result.data.user_nama,
                        mapel : result.data.mapel_nama,
                        kelasNama : result.data.kelasNama,
                        dataParticipant,
                        dataExport: result.data['jawab'],
                        dataSiswa: result.data['jawab'],
                        dataExportNotE: result.data['notJawab'],
                        dataSiswaNotE: result.data['notJawab'],
                        isLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    exportFile() {
        this.setState({ isButtonLoading: true });

        let presensi = [["Guru",this.state.guru]]
        presensi.push(["Mata Pelajaran",this.state.mapel])
        presensi.push(["Tanggal Mulai",this.state.tanggal_mulai])
        presensi.push(["Batas Pengumpulan",this.state.due_date])
        presensi.push([""])
        presensi.push(["NAMA", "NISN", "KELAS", "TANGGAL PENGUMPULAN", "FILE", "LINK JAWABAN", "NILAI","STATUS"])

        this.state.dataExport.map(item => {
            presensi.push([
                item.user_nama,
                item.siswa_nisn,
                item.kelas_nama,
                item.ta_create_date,
                item.ta_url_bulk,
                item.ta_url,
                item.ta_nilai ? item.ta_nilai : 0,
                item.ta_status.toU
            ])
        })

        let notExam = [["NAMA", "NISN", "NILAI"]]

        this.state.dataExportNotE.map(item => {
            notExam.push([
                item.user_nama,
                item.siswa_nisn,
                '0',
                'Belum Mengerjakan'
            ])
        })

        const wb = XLSX.utils.book_new();
        const wsAll = XLSX.utils.aoa_to_sheet(presensi);
        const wsNotEx = XLSX.utils.aoa_to_sheet(notExam);

        XLSX.utils.book_append_sheet(wb, wsAll, this.state.kelasNama + 'Ujian')
        XLSX.utils.book_append_sheet(wb, wsNotEx, this.state.kelasNama + 'Belum')

        XLSX.writeFile(wb, "Rekap Nilai Tugas-"+ this.state.kelasNama+".xlsx")
        this.setState({ isButtonLoading: false });
    }



    componentDidMount() {
        this.loadData();
        // this.loadExport();
        // this.loadDataParti();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.participant_id !== this.state.participant_id || prevState.nama !== this.state.nama) {
            this.loadData()
            // this.loadExport()
        }
    }

    render() {
        return (
            <div>

                <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            Detail Report Nilai
                                <button

                                    className="btn btn-primary btn-sm float-right"
                                    disabled={this.state.isButtonLoading && "disabled" || this.state.dataExport.length === 0 && "disabled"}
                                    onClick={this.exportFile}>
                                    {this.state.isButtonLoading || this.state.dataExport.length === 0 ? "Menyiapkan file..." : "Export Nilai"}
                                </button>
                                {" "}
                                <button
                                    style={{ marginRight:'10px' }}
                                    className="btn btn-primary btn-sm float-right"
                                    disabled={this.state.isButtonLoading && "disabled" }
                                    onClick={this.downloadZip}>
                                    {this.state.isButtonLoading  ? "Menyiapkan file..." : "Download Zip File"}
                                </button>
                        </div>
                        <div className="card-block">
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">Guru</label>
                                <div className="col-md-10">
                                    {": "}<b>{this.state.guru}</b>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">Kelas</label>
                                <div className="col-md-10">
                                    {": "}<b>{this.state.kelasNama}</b>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">Mata pelajaran</label>
                                <div className="col-md-10">
                                    {": "}<b>{this.state.mapel}</b>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">Tanggal Mulai</label>
                                <div className="col-md-10">
                                    {": "}<b>{this.state.tanggal_mulai}</b>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">Batas Pengumpulan</label>
                                <div className="col-md-10">
                                    {": "}<b>{this.state.due_date}</b>
                                </div>
                            </div>
                            <br/><br/>
                            <div className="col-md-12 form-group row">
                                <div className="col-md-6">
                                    <DropdownView
                                        handleChange={this.handleChange}
                                        stateName="participant_id"
                                        label="Pilih Kelas Peserta"
                                        disabled={this.props.mode === 'Edit' ? true : false}
                                        items={this.state.dataParticipant}
                                        value={this.state.participant_id}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        name="nama"
                                        type="text"
                                        className="form-control"
                                        placeholder="Ketikkan Nama Pengguna..."
                                        value={this.state.nama}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                </div>
                <div className="row">
                    <div className="row col-md-12">
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header">Data Siswa Upload Tugas</div>
                                <div className="card-block">
                                    {this.state.isLoading ? (
                                        "Memuat Data..."
                                    ) : this.state.dataSiswa.length === 0 ? (
                                        "Data Kosong..."
                                    ) : (
                                        <div>
                                            <div className="card">
                                                <table className="table table-striped table-bordered animated fadeIn">
                                                    <thead>
                                                    <tr>
                                                        <th width={10}>NO</th>
                                                        <th>NAMA SISWA</th>
                                                        <th>NISN</th>
                                                        <th>NILAI</th>
                                                        <th width={100}>STATUS</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.state.dataSiswa.map((items,i) => {
                                                        return (
                                                            <tr key={items.user_id}>
                                                                <td>{i+1}</td>
                                                                <td>{items.user_nama}</td>
                                                                <td>{items.siswa_nisn}</td>
                                                                <td>{items.ta_nilai ? items.ta_nilai : 0}</td>
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className={`btn btn-sm ${
                                                                            items.ta_status != null
                                                                                ? "btn-primary"
                                                                                : "btn-warning"
                                                                            }`}

                                                                    >
                                                                        {items.ta_status != null ? items.ta_status : 'uncorections'}
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header">Data Siswa Belum Upload Tugas</div>
                                <div className="card-block">
                                    {this.state.isLoading ? (
                                        "Memuat Data..."
                                    ) : this.state.dataSiswaNotE.length === 0 ? (
                                        "Data Kosong..."
                                    ) : (
                                        <div>
                                            <div className="card">
                                                <table className="table table-striped table-bordered animated fadeIn">
                                                    <thead>
                                                    <tr>
                                                        <th width={10}>NO</th>
                                                        <th>NAMA SISWA</th>
                                                        <th width={100}>STATUS</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.state.dataSiswaNotE.map((items,i) => {
                                                        return (
                                                            <tr key={items.siswa_id}>
                                                                <td>{i+1}</td>
                                                                <td>{items.user_nama}</td>
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-warning"

                                                                    >
                                                                        BELUM UPLOAD TUGAS
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

export default ScoreTugasOffline;



// WEBPACK FOOTER //
// ./src/views/Exam/Report/ScoreTugasOffline.js